/** @format */
import React, { useState, useEffect, useCallback } from 'react';
import { useStyles } from './style';
import { Tabs, Tab, Typography, Box, Grid } from '@mui/material';
import { Link as RouterLink, useLocation, NavLink } from 'react-router-dom';
import { VersionDialog } from './components';
import clsx from 'clsx';
import Services from './services/Services';
import { useMenuDispatcher, useActionDispatcher } from 'hooks';
import { ShimmerLoading, Icons } from 'components';
import { useNavigate } from 'react-router-dom';
import ListItemText from '@mui/material/ListItemText';

const SidebarNew = (props) => {
  const classes = useStyles();
  const location = useLocation();
  const [value, setValue] = useState(0); // مقدار آنچنج تب در سایدبار
  const [menu, setMenu] = useState([]); // لیست منو
  const [isMini, setIsMini] = useState(true); // collapse menu
  const [isLoadingVersion, setIsLoadingVersion] = useState(true); // collapse menu
  const [isLoading, setIsLoading] = useState(true); // لودینگ
  const [isOpenHistroyDg, setIsOpenHistoryDg] = useState(false); // لودینگ
  const [pages, setPages] = useState([]);
  const [showError, setShowError] = useState(false); // در صورت خطا خوردن سرویس منو
  const setPermission = useMenuDispatcher();
  const setAction = useActionDispatcher();
  const [isActive, setIsActive] = useState(false);
  const [isOpenNew, setIsOpenNew] = useState(null);
  const [data, setData] = useState([]);
  const navigate = useNavigate();
  const { setIsShowContent } = props;

  useEffect(() => {
    setIsActive(false)
    let url = location?.pathname.split('?')[0];
    // بررسی صفحه اصلی بودن در نمایش سایدبار
    if (url === '/Home' || url === '/home' || url === '/') {
      setValue(0);
      setIsShowContent(true);
      setIsMini(true);
    } else {
      setIsShowContent(false);
      setIsMini(false);
      const index = findIndexByLink(menu, url);

      if (index !== -1) {
        setValue(index);
      } else {
        setValue(null);
        setIsShowContent(true);
        setIsMini(true);
      }
    }
    if (url === '/Faq') {
      setTimeout(() => {
        setIsActive(true)
      }, 100)
    }
  }, [location?.pathname.split('?')[0]]);


  // اگر صفحه میزبان باشد محتوای سایدبار بسته میماند در غیر این صورت باز میماند
  useEffect(() => {
    setIsActive(false)
    if (value === 0 && location?.pathname !== '/Home' && menu[0]?.link === '/Home' && !isLoading) {
      navigate('/Home');
    }
    if (
      (value === 0 && menu[0]?.link === '/Home') ||
      value === null ||
      menu[0]?.link === undefined
    ) {
      setIsShowContent(true);
      setIsMini(true);
    } else {
      setIsShowContent(false);
      setIsMini(false);
    }
  }, [value]);


  useEffect(() => {
    if (localStorage.getItem('DataFetched') == '1') {
      // هر زمانی که کاربر لاگین کند این فیلد پر میشود و بعد از آن متوجه میشیم که توکن بدرستی پر شده است
      getMenu(1);
    }
  }, [localStorage.getItem('DataFetched')]);


  /**
* دریافت لیست نسخه ها و ورژن ها
*/
  const getHistoryVersion = () => {
    setIsLoadingVersion(true)

    Services
      .getHistoryVersions()
      .then((res) => {
        let d = res?.result?.versions;


        setData(d);
        setIsLoadingVersion(false)
      })


  };


  // --API REQUESTS--//
  const goToTab = () => {
    navigate('/Faq');
    setValue(null);
    setIsShowContent(true);
    setIsMini(true);
    setTimeout(() => {
      setIsActive(true)
    }, 10)

  };

  // این تابع در صورت لود صفحه آدرس صفحه را پیدا کرده و در تب مربوطه باز میشود

  const findIndexByLink = (array, link) => {
    return array.findIndex(
      (item) =>
        Array.isArray(item.items) &&
        item.items.some((subItem, subIndex) =>
          Array.isArray(subItem.items)
            ? subItem.items.some((thirdLevelItem) =>
              Array.isArray(thirdLevelItem.items)
                ? thirdLevelItem.items.includes(link)
                : (location?.pathname !== '/cards' ? setIsOpenNew(subItem?.key) : '',
                  thirdLevelItem.link === link),
            )
            : subItem.link === link,
        ),
    );
  };

  const toggleItem = useCallback(

    (itemKey) => {
      setIsOpenNew(isOpenNew === itemKey ? null : itemKey);
    },
    [isOpenNew],
  );

  //سرویس دریافت منو
  const getMenu = async (tryCount) => {
    setIsLoading(true);
    setIsShowContent(true);
    setIsMini(true);
    await Services.getMenus()
      .then((res) => {
        let result = JSON.stringify(res?.result?.menus);
        let permissions = JSON.stringify(res?.result?.actions);
        let reportPages = JSON.stringify(res?.result?.newReports);
        getHistoryVersion()
        setShowError(false);
        createObjectPages(JSON.parse(result));
        convertPermissionModel(JSON.parse(permissions));
        setIsLoading(false);
        setMenu(JSON.parse(result));
        setAction([JSON.parse(permissions), JSON.parse(reportPages)]);
        const targetLink = location?.pathname;
        const index = findIndexByLink(JSON.parse(result), targetLink);
        if (location?.pathname === '/Home') {
          setValue(0);
        } else {
          if (index !== -1) {
            setValue(index);
          } else {
            setValue(null);
          }
        }
      })
      .catch((error) => {
        setIsLoading(true);
        setIsShowContent(true);
        tryCount = tryCount ? tryCount + 1 : 1;
        if (tryCount > 4) {
          setShowError(true);
          setIsLoading(false);
          return;
        }
        getMenu(tryCount);
      });
  };

  // بررسی دتسرسی های منو و صفحه
  const convertPermissionModel = (keys) => {
    setPermission(keys);
  };

  //ایجاد آبجکت از منو
  const createObjectPages = (model) => {
    model.forEach((item) => {
      if (item.items && item.items.length > 0) {
        item.items.forEach((childItem) => {
          childItem.isOpenChild = false;
        });
      }
    });

    let myPages = [];
    for (let item of model) {
      myPages.push({
        name: item.name,
        link: item.link || '',
        IconName: item.icon,
        items: item.items || [],
      });
    }

    setPages(myPages);
  };

  const TabPanel = ({ children, value, index }) => {
    return value === index && <Box>{children}</Box>;
  };

  const onChangeTab = (newValue) => {
    setValue(newValue);
    setIsOpenNew(null);

    if (newValue === value && menu[newValue].items.length !== 0) {
      //اگر محتوای سایدبار بسته بود با زدن بر روی تب اکتیو مجدد باز میشود
      setIsShowContent(false);
      setIsMini(false);
    }
  };

  return (
    <div className={clsx(classes.sidebar, isMini ? '' : 'showContent')}>
      <div className={classes.sidebarBlock}>
        <div className={classes.sidebarTab}>
          <Grid
            container
            justifyContent="flex-start"
            className={classes.logoContainer}
            alignItems="center"
          >
            <RouterLink to="/Home" className={classes.logoLight}>
              <img alt="Logo" className={classes.logo} src="./images/pod/logo-white.svg" />
            </RouterLink>
          </Grid>
          <Box>
            <div className={classes.tabsContent}>
              {isLoading ? (
                <Grid item xs={12}>
                  <ShimmerLoading />
                </Grid>
              ) : showError ? (
                <Grid item xs={12}>
                  <div className={classes.menuError}>
                    خطا در دریافت لیست منوها
                    <br />
                    <a href={(e) => e.preventDefault()} onClick={() => getMenu(2)}>
                      تلاش مجدد
                    </a>
                  </div>
                </Grid>
              ) : (
                <Tabs
                  value={value}
                  onChange={(_event, newValue) => onChangeTab(newValue)}
                  orientation="vertical"
                  indicatorColor="#4050AC"
                  className={classes.tabs}
                >
                  {menu.map((tab) => (
                    <Tab
                      key={tab.key.toString()}
                      value={tab.id}
                      onClick={() => {
                        if (tab.link !== '/Home') {
                          setIsShowContent(false);
                          setIsMini(false);
                        }
                      }}
                      className={classes.tab}
                      label={
                        <Box>
                          <div className={classes.icons}>
                            <Icons icon={tab.icon} color="#fff" size="25" />
                          </div>
                          <Typography whiteSpace="nowrap" className={classes.tabText}>
                            {tab.name}
                          </Typography>
                        </Box>
                      }
                    />
                  ))}

                  <Tab
                    className={clsx(classes.tab, isActive ? 'Mui-selected' : '')}
                    onClick={() => goToTab()}
                    key={100}
                    value={100}
                    label={
                      <Box>
                        <div className={classes.icons}>
                          <Icons icon="QuestionCircle" color="#fff" size="25" />
                        </div>
                        <Typography whiteSpace="nowrap" className={classes.tabText}>
                          سوالات متداول
                        </Typography>
                      </Box>
                    }
                  />

                </Tabs>
              )}
            </div>
            {isLoadingVersion ? '' :
              <div
                className={classes.version}
                onClick={() => {
                  setIsOpenHistoryDg(true);
                }}
              >
                نسخه
                <div
                  style={{
                    fontFamily: 'Vazir',
                    direction: 'ltr',
                    display: 'inline-block',
                    marginRight: '5px'
                  }}
                >
                  {data[0]?.version}
                </div>
              </div>
            }
          </Box>
        </div>
        <div className={clsx(classes.sidebarContent, isMini ? '' : 'showContent')}>
          {pages.map((item, d) => (
            <TabPanel value={value} index={d}>
              <div
                className={classes.tabContentDetail}
                style={{
                  opacity: isMini ? 0 : 1,
                  transition: 'opacity 0.3s ease-in-out',
                  visibility: 'visible',
                }}
              >
                <Box className={classes.subjectTabs}>
                  <Icons icon={pages[d].IconName} color="#fff" size="150" />
                </Box>
                <div
                  className={clsx(classes.arrowRight, isMini ? '' : 'showArrow')}
                  onClick={() => {
                    setIsShowContent(true);
                    setIsMini(true);
                  }}
                >
                  <Icons icon="ChevronRight" color="#fff" size="25" />
                </div>

                {item?.items.map(
                  (data, index) =>
                    value === d && (
                      <div
                        className={clsx(
                          classes.blockList,
                          isOpenNew === data.key ? 'activeItem' : '',
                        )}
                      >
                        {data?.items?.length > 0 ? (
                          <>
                            <span className={classes.arrow} onClick={() => toggleItem(data.key)}>
                              {isOpenNew === data.key ? <Icons icon="CaretUp" color="#fff" size="50" /> : <Icons icon="CaretDown" color="#fff" size="50" />}
                            </span>
                            <ListItemText
                              primary={data?.name}
                              className={clsx(
                                classes.listItemTextItems,
                                isOpenNew === data.key ? 'expand' : '',
                              )}
                              onClick={() => toggleItem(data.key)}
                            />
                            <div
                              className={
                                isOpenNew === data.key ? classes.showCollapse : classes.hideCollapse
                              }
                            >
                              {data?.items.map((childItem) => (
                                <>
                                  <NavLink
                                    component="div"
                                    disablePadding
                                    to={childItem?.link}
                                    className={clsx(
                                      classes.listItemTextNested,
                                      location?.pathname === childItem?.link ? 'activeLink' : '',
                                    )}
                                  >
                                    <ListItemText primary={childItem.name} />
                                  </NavLink>
                                </>
                              ))}
                            </div>
                          </>
                        ) : (
                          <>
                            <NavLink
                              to={data?.link}
                              className={clsx(
                                classes.listItemText,
                                location?.pathname === data?.link ? 'activeLink' : '',
                              )}
                              onClick={() => setTimeout(() => {
                                setIsOpenNew(null)
                              }, 0)}

                            >
                              {data?.name}
                            </NavLink>
                          </>
                        )}
                      </div>
                    ),
                )}
              </div>
            </TabPanel>
          ))}
        </div>
      </div>
      <VersionDialog data={data} isLoading={isLoadingVersion} setIsLoading={setIsLoadingVersion} setData={setData} open={isOpenHistroyDg} setOpen={setIsOpenHistoryDg} />
    </div>
  );
};

export default SidebarNew;
